<db-dialog-wrapper [dialog]="this"
                   [width]="isMobile ? null: '1000px'"
                   height="640px"
                   [whiteCloseBtn]="!isMobile"
                   [fullScreen]="isMobile"
                   [noBorder]="true">
  <div class="db-manual-migration-dialog__wrapper" *ngIf="step === 1">
    <div class="db-manual-migration-dialog__content-wrapper">
      <div class="db-manual-migration-dialog__content">
        <div class="ds-notification-error mb15"
             *ngIf="ErrMessage">
          <div>
            <i class="db-icon db-icon-ds-info-bg"></i>
            <p>
              <span [innerHTML]="'Something on your website is preventing automated migration'"></span>
            </p>
          </div>
        </div>
        <div class="db-manual-migration-dialog__title">
          {{'text_manualMigrationDialogTitle'|dbText}}
          <span>{{'text_manualMigrationDialogTitleAccent'|dbText}}</span>
        </div>
        <div class="db-manual-migration-dialog__subtitle">
          {{'text_manualMigrationDialogSubtitle'|dbText}}
        </div>
        <div class="db-manual-migration-dialog__warning">
          {{'text_manualMigrationDialogWarning'|dbText}}
        </div>
        <form class="db-manual-migration-dialog__body" [formGroup]="migrateWebsiteForm" (ngSubmit)="submit()">
          <div class="ds-input-wrap static mb28 mt25">
            <span class="ds-input-label">Subdomain</span>
            <div class="db-manual-migration-dialog__subdomain">
              <input type="text" class="ds-input mr20" maxlength="56"
                     [class.error]="formSubmitted && migrateWebsiteForm?.get('subdomain')?.errors"
                     placeholder="*subdomain" formControlName="subdomain">
              <div class="separator"></div>
              <span>.{{configHostname}}</span>
            </div>
            <span *ngIf="formSubmitted && migrateWebsiteForm?.get('subdomain')?.errors" class="ds-input-error-msg"
                  [innerHTML]="migrateWebsiteForm?.get('subdomain')?.errors['required'] ?
            'This field is required.':
            migrateWebsiteForm?.get('subdomain')?.errors?.pattern ? ('text_fillFieldAllowedLetters' | dbText) :
            migrateWebsiteForm?.get('subdomain')?.errors?.taken ? migrateWebsiteForm?.get('subdomain')?.errors?.taken
            : ''"></span>
            <span class="ds-input-desc">{{ 'text_subDomainDescription' | dbText}}</span>
          </div>

          <div class="ds-input-wrap static mb28">
            <ds-dropdown [dsDropdownOptions]="regions"
                         [value]="migrateWebsiteForm.get('region').value"
                         formControlName="region"
                         [dsDropdownDisabled]="userSubscription?.type === UserSubscriptionCategory.DedicatedVM"
                         [dsDropdownLabel]="('text_regionDescription' | dbText)"></ds-dropdown>
          </div>
        </form>
      </div>
      <div class="db-manual-migration-dialog__actions">
        <button class="ds-btn-black" (click)="submit()">{{'text_continue' |dbText}}</button>
      </div>
    </div>
    <div class="db-manual-migration-dialog__banner" *ngIf="!isMobile">
      <img src="assets/images/backgrounds/manual-migration-banner.png" alt="">
    </div>
    <db-loading-screen [pageBlocker]="true"
                       *ngIf="loading">
    </db-loading-screen>
  </div>
  <db-migration-zip-upload *ngIf="step===2" (back)="step = 1; loading = false"  (startLoading)="startLoading($event)"></db-migration-zip-upload>
</db-dialog-wrapper>
